import { ChangeEventHandler, FC, useRef } from "react";
import { useTranslation } from "react-i18next";
import { Badge, Typography } from "@mui/material";
import { EditOutlined } from "@mui/icons-material";
import { AppConstant } from "@/const";
import { SystemUtils } from "@/utils";
import { AvatarContainer, ProfileAvatar, UpdateAvatarButton } from "../Profile.style";

const HIDDEN_INPUT_ID: string = "avatar-image-upload";

type ChangeAvatarFormProps = {
  userName: string;
  avatar?: string;
  position?: string;
  department?: string;
  onChange?: (file: File) => void;
};

const ChangeAvatarForm: FC<ChangeAvatarFormProps> = ({ avatar, userName, position, department, onChange }) => {
  const { t: getLabel } = useTranslation();
  const avatarInputRef = useRef<HTMLInputElement>(null);

  const handleChangeAvatar: ChangeEventHandler<HTMLInputElement> = event => {
    const fileList = event.target.files;
    const file = fileList && fileList.length > 0 ? fileList.item(0) : null;
    if (onChange && file) onChange(file);
    if (avatarInputRef.current) avatarInputRef.current.value = "";
  };

  return (
    <AvatarContainer variant="outlined">
      <Badge
        overlap="circular"
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        badgeContent={
          <UpdateAvatarButton htmlFor={HIDDEN_INPUT_ID}>
            <input
              hidden
              type="file"
              ref={avatarInputRef}
              id={HIDDEN_INPUT_ID}
              onChange={handleChangeAvatar}
              accept={AppConstant.ACCEPT_IMAGE_MIME_TYPES.join(",")}
            />
            <EditOutlined color="primary" fontSize="small" />
          </UpdateAvatarButton>
        }
      >
        <ProfileAvatar alt={userName} src={SystemUtils.getAttachmentFromPath(avatar)}>
          {userName && userName.length > 0 ? userName.charAt(0) : null}
        </ProfileAvatar>
      </Badge>
      <Typography variant="h5" textAlign="center">
        {userName}
      </Typography>
      <Typography variant="body2" color="#007ACB">
        {position || getLabel("L_SUPERVISOR")}
      </Typography>
      {department ? (
        <Typography variant="body2" color="#BDBDBD" align="center">
          {department}
        </Typography>
      ) : (
        <Typography variant="body2" color="#BDBDBD" align="center">
          Vietnam Coast Guard <br /> (Bộ Tư lệnh Cảnh sát biển Việt Nam)
        </Typography>
      )}
    </AvatarContainer>
  );
};

export default ChangeAvatarForm;
